import $ from 'jquery';
import Singleton from 'components/utils/Singleton';
import 'jquery.extendPrototype';
  function InputMonth(settings) {
    this.settings = $.extend(true, {}, this.settings, settings || {});
    this.initialize();
  }

  $.extendPrototype(InputMonth, {
    settings: {
      selector: '.js-input-month',
    },
    initialize() {
      const $input = $(this.settings.selector);

      const yearSelector = $input.data('rel-year');
      const monthSelector = $input.data('rel-month');
      const $yearInput = $(yearSelector);
      const $monthInput = $(monthSelector);

      $input.on('change', function (event) {
        // standard format yyyy-MM
        const selectedYearMonth = $(event.target)
          .val()
          .split('-');

        $yearInput.val(selectedYearMonth[0]);
        $monthInput.val(selectedYearMonth[1]);
      });
    },
  });

  export default Singleton.create(InputMonth, 'InputMonth');

